import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SessionService } from '../../shared/services';
import { StateManager } from '@shared/services/state-manager/state-manager.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const router = inject(Router);
  const session = inject(SessionService);
  const _translate = inject(TranslateService);
  const stateManager = inject(StateManager);
  const oldReIssueToken = session.reissueToken || '';
  const reIssueToken = (route.queryParams || route.parent?.queryParams)?.rt || '';
  const bankId = (route.queryParams || route.parent?.queryParams)?.bankId || '';
  const lang = (route.queryParams || route.parent?.queryParams)?.lang || '';

  if (reIssueToken && reIssueToken !== oldReIssueToken && reIssueToken !== session.syncToken) {
    return session.updateSession(reIssueToken, bankId).pipe(
      map(isLoggedIn => {
        if (isLoggedIn) {
          const url: UrlTree = router.parseUrl(state.url);
          delete url.queryParams.rt;
          delete url.queryParams.bankId;
          if (lang) {
            stateManager.update('user-locale', { language: lang }, false);
            _translate.use(lang);
          }
          return url;
        }
        return false;
      })
    );
  } else {
    if (!session.isLoggedIn()) {
      session.setUrlParameter(state.url);
      return router.navigate(['/auth']);
    }
    return true;
  }
};
